
import { PostgrestError } from '@supabase/supabase-js';

export type SaveStateError = PostgrestError | Error;

/**
 * Parses database error codes and returns user-friendly error messages
 */
export const getErrorMessage = (error: SaveStateError): string => {
  if ('code' in error) {
    // Handle Supabase PostgrestError
    const pgError = error as PostgrestError;
    
    switch (pgError.code) {
      case '23505':
        // Unique constraint violation
        return pgError.details?.includes('name')
          ? "A state with this name already exists. Please use a different name."
          : "This country/league/year combination already exists.";
      case '23503':
        return "Referenced record does not exist. Please check country, league and year values.";
      case '23502':
        return "Missing required fields. Please ensure all required fields are filled.";
      default:
        return `Database error: ${pgError.message || pgError.code}`;
    }
  }
  
  // Handle standard Error
  return error.message || "An unknown error occurred";
};

/**
 * Determines the most user-friendly error message from different error types
 */
export const extractUserFriendlyMessage = (error: any): string => {
  let errorMessage = "Failed to save state. Please try again.";
  
  if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'object' && error !== null) {
    // Handle Supabase error object
    if ('message' in error) {
      errorMessage = error.message as string;
    } else if ('error' in error) {
      errorMessage = (error.error as string) || errorMessage;
    } else if ('details' in error) {
      errorMessage = (error.details as string) || errorMessage;
    }
  }
  
  return errorMessage;
};

